/* eslint-disable camelcase */
import React, {
    FC, useContext, useEffect, useMemo,
} from 'react';
import classNames from 'classnames';
import queryString from 'query-string';

import formatPrice from 'app/utils/price';
import { menuDishesIdListVar } from 'app/apollo/reaction';
import { useReactiveVar } from '@apollo/client';
import { TWO_DAYS_IN_UTC_FORMAT } from 'app/containers/contexts/menuDates.consts';
import { menuDatesState } from 'app/containers/contexts/menuDates.context';
import { set } from 'lodash';
import { useDynamicSetPrice } from './hooks/useDynamicSetPrice';

import { ISetCard } from './types';
import { TCardKey } from '../../sets.record';

import SetSmallShieldIcon from './img/set320new.component.svg';
import SetMediumShieldIcon from './img/set375new.component.svg';

import css from './BR1258sets5dishes.module.scss';


const cardShildColorMap: Record<TCardKey, any> = {
    TRIAL_FIRST_ORDER_SET: {
        bg: 'green',
        text: 'green',
    },
    EVERYDAY_SET: {
        bg: '#FE645B',
        text: '#FFD8CC',
    },
    PREMIUM_SET_GREEN_VERSION: {
        bg: '#91D579',
        text: '#CFF9C8',
    },
    OUR_SET: {
        bg: '#FF9371',
        text: '#FFD8CC',
    },
    HALLOWEEN_SET: {
        bg: '#FF9371',
        text: '#FFD8CC',
    },
};

const BR1258Sets5DishesCardItem: FC<ISetCard> = ({
    cardKey,
    isDynamicPrice,
    title = '',
    description = '',
    price = '',
    disabled = false,
    iconClass = null,
    isAdditionalSet = false,
    onClick = () => { },
}: ISetCard) => {
    const formattedDescription = description.split('\n').map((item) => (
        <div key={item}>
            {item}
            <br />
        </div>
    ));

    const cardClass = classNames({
        [css.sliderCardNewUI]: true,
        [css[iconClass || '']]: Boolean(iconClass),
        mock: !iconClass,
    });

    const smallShieldClasses = classNames({
        [css.cardShieldNewUI]: true,
        [css.cardShieldSmallNewUI]: true,
    });

    const mediumShieldClasses = classNames({
        [css.cardShieldNewUI]: true,
        [css.cardShieldMediumNewUI]: true,
    });

    return (
        <button
            className={cardClass}
            onClick={onClick}
            type="button"
            disabled={disabled}
        >

            <div className={css.infoTextContainerNewUI}>
                <div className={`body-xl-semibold ${css.infoTitleNewUI}`}>
                    {title}
                </div>
                <div className={`body-xs-medium ${css.infoDescriptionNewUI}`}>
                    {formattedDescription}
                </div>
            </div>
            {cardKey && !isAdditionalSet && (
                <>
                    <div className={smallShieldClasses}>
                        <SetSmallShieldIcon
                            fill={cardShildColorMap[cardKey].bg}
                            style={{ color: cardShildColorMap[cardKey].text }}
                        />
                    </div>
                    <div className={mediumShieldClasses}>
                        <SetMediumShieldIcon
                            fill={cardShildColorMap[cardKey].bg}
                            style={{ color: cardShildColorMap[cardKey].text }}
                        />
                    </div>
                </>
            )}
            <div className={css.cutoutTextNewUI}>
                <div className={css.cutoutTextWrapperNewUI}>
                    <div className={`other-number-s-medium ${css.priceTextNewUI}`}>
                        {(isDynamicPrice)
                            ? formatPrice(price)
                            : price}
                    </div>
                </div>
            </div>
        </button>
    );
};

const BR1258Sets5DishesCardWrapper: FC<ISetCard> = (props: ISetCard) => {
    const menuDish_IDs = useReactiveVar(menuDishesIdListVar);
    const { state: { dateFilterStatus, selectedPeriodIndex } } = useContext(menuDatesState);

    const isInFirstPeriod = selectedPeriodIndex === 0;
    // @ts-expect-error
    const isX1orX2 = (dateFilterStatus - TWO_DAYS_IN_UTC_FORMAT) <= 0;

    const {
        setType, isDynamicPrice, recurrentPrice = '',
        setHasNoDishes = () => { },
    } = props;

    const searchParams = queryString.parse(window.location.search);

    const {
        priceOfSet, hasDishesInSet, sections_IDs,
    } = useDynamicSetPrice(setType);

    const isSetDishesInMenu = useMemo(() => {
        if (setType === 'tomorrow') {
            return true;
        }
        const result = sections_IDs?.some((id: string) => {
            // @ts-expect-error
            const index = menuDish_IDs?.indexOf(id);
            return index === -1;
        });
        return !result;
    }, [setType, menuDish_IDs, sections_IDs]);

    useEffect(
        () => {
            if (!hasDishesInSet) {
                // @ts-ignore
                setHasNoDishes((prev: boolean[]) => [...prev, true]);
                return;
            }
            // @ts-ignore
            setHasNoDishes((prev: boolean[]) => [...prev, false]);
        },
        [hasDishesInSet, setType, setHasNoDishes],
    );

    if (isX1orX2 && isInFirstPeriod && setType !== 'tomorrow') {
        return null;
    }

    if (!hasDishesInSet) {
        return null;
    }

    // if (!isSetDishesInMenu) {
    //     return null;
    // }

    return (
        <BR1258Sets5DishesCardItem
            {...props}
            // @ts-expect-error
            price={
                isDynamicPrice
                    ? Math.round(priceOfSet * 0.9)
                    : recurrentPrice
            }
        />
    );
};

export { BR1258Sets5DishesCardWrapper as BR1258Sets5DishesCard };
